import React from 'react';
import { AuthProvider } from '@shared/auth/AuthContext';
import { ThemeProvider } from '@shared/contexts/ThemeContext';
import { DeveloperModeProvider } from '@shared/contexts/DeveloperModeContext';
import { QueryProvider } from '@shared/query/QueryProvider';
import { RealtimeProvider } from '@shared/realtime/RealtimeProvider';
import { OfflineProvider } from '@shared/offline/OfflineProvider';
import { SyncProvider } from '@shared/sync/SyncProvider';
import { RBACProvider, PermissionProvider, SessionProvider } from '@shared/security';
import { AnalyticsProvider } from '@shared/analytics/provider';

interface SharedProvidersProps {
  children: React.ReactNode;
}

export const SharedProviders: React.FC<SharedProvidersProps> = ({ children }) => {
  return (
    <QueryProvider>
      <ThemeProvider>
        <AuthProvider>
          <DeveloperModeProvider>
            <RBACProvider>
              <PermissionProvider>
                <SessionProvider>
                  <OfflineProvider>
                    <SyncProvider>
                      <RealtimeProvider>
                        <AnalyticsProvider>
                          {children}
                        </AnalyticsProvider>
                      </RealtimeProvider>
                    </SyncProvider>
                  </OfflineProvider>
                </SessionProvider>
              </PermissionProvider>
            </RBACProvider>
          </DeveloperModeProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryProvider>
  );
};
export default SharedProviders;
